(function () {
  'use strict';
  if (window.gsCartResilienceLoaded) return;
  window.gsCartResilienceLoaded = true;
  var namespace = window.theme = window.theme || {};
  var pending = null;
  var uncertain = false;
  var timeoutMs = 20000;

  function feedbackFor(form) {
    return form && form.querySelector('[data-gs-cart-feedback]');
  }

  function restoreAttribute(element, name, value) {
    if (value === null) element.removeAttribute(name);
    else element.setAttribute(name, value);
  }

  function finish(operation) {
    clearTimeout(operation.timer);
    operation.instance.addToCart.classList.remove('btn--loading');
    restoreAttribute(operation.instance.form, 'aria-busy', operation.busyBefore);
    restoreAttribute(operation.instance.addToCart, 'aria-disabled', operation.disabledBefore);
    if (pending === operation) pending = null;
  }

  function showFailure(instance, error, ambiguous) {
    var feedback = feedbackFor(instance.form);
    var fallback = feedback.dataset.gsCartError;
    if (ambiguous) uncertain = true;
    feedback.hidden = false;
    if (uncertain) instance.form.setAttribute('data-gs-cart-uncertain', 'true');
    var value = error && typeof error === 'object' ? error : {};
    if (!value.description) value = Object.assign({}, value, {description: value.message || fallback});
    if (!value.message) value = Object.assign({}, value, {message: fallback});
    instance.error(value);
    var notice = instance.form.querySelector('.errors');
    var message = feedback.querySelector('[data-gs-cart-message]');
    if (notice && message) message.replaceChildren(notice);
    if (uncertain) {
      var link = feedback.querySelector('a');
      if (link) link.focus({preventScroll: true});
    }
  }

  function validLine(line) {
    return line && typeof line === 'object' && /^\d+$/.test(String(line.id)) &&
      Number(line.id) > 0 && Number.isInteger(line.quantity) && line.quantity > 0;
  }

  function validAddition(data) {
    if (!data || typeof data !== 'object' || Array.isArray(data)) return false;
    if (data.errors || Number(data.status) >= 400) return false;
    if (Array.isArray(data.items)) return data.items.length > 0 && data.items.every(validLine);
    return validLine(data);
  }

  function install(Constructor) {
    if (typeof Constructor !== 'function' || !Constructor.prototype || Constructor.prototype.gsCartResilience) return;
    var prototype = Constructor.prototype;
    var original = prototype.addItemFromForm;
    if (typeof original !== 'function' || typeof prototype.success !== 'function' || typeof prototype.error !== 'function') return;
    prototype.gsCartResilience = true;
    prototype.addItemFromForm = function (event, callback) {
      var feedback = feedbackFor(this.form);
      if (!feedback || !this.addToCart) return original.call(this, event, callback);
      event.preventDefault();
      if (pending) return;
      if (uncertain) {
        showFailure(this, null, true);
        return;
      }
      if (this.addToCart.disabled) return;
      var payload;
      try { payload = new FormData(this.form); }
      catch (_) { showFailure(this, null, false); return; }
      var instance = this;
      var operation = {
        instance: this,
        controller: new AbortController(),
        busyBefore: this.form.getAttribute('aria-busy'),
        disabledBefore: this.addToCart.getAttribute('aria-disabled')
      };
      pending = operation;
      this.form.setAttribute('aria-busy', 'true');
      this.addToCart.setAttribute('aria-disabled', 'true');
      this.addToCart.classList.add('btn--loading');
      feedback.hidden = true;
      var timeout = new Promise(function (_, reject) {
        operation.timer = setTimeout(function () {
          reject(new Error('Cart response timeout'));
          operation.controller.abort();
        }, timeoutMs);
      });
      var request = Promise.resolve().then(function () {
        return fetch(namespace.routes.cartAdd, {
          method: 'POST',
          body: payload,
          headers: {'X-Requested-With': 'XMLHttpRequest'},
          signal: operation.controller.signal
        });
      }).then(function (response) {
        if (response.redirected) throw new Error('Unexpected cart redirect');
        return response.json().then(function (data) {
          var status = response.status;
          var payloadStatus = Number(data && data.status);
          if ((status === 400 || status === 404 || status === 422 || status === 429 || response.ok && payloadStatus === 422) &&
              data && typeof data === 'object' && (data.description || data.message)) {
            return {kind: 'rejected', data: data};
          }
          if (!response.ok || !validAddition(data)) throw new Error('Unconfirmed cart response');
          return {kind: 'added', data: data};
        });
      });
      return Promise.race([request, timeout]).then(function (result) {
        if (result.kind === 'rejected') {
          showFailure(instance, result.data, false);
          return;
        }
        instance.success(result.data);
        if (document.body.classList.contains('template-cart') && namespace.settings.cartType !== 'page') {
          window.scrollTo(0, 0);
          window.location.reload();
        }
      }).catch(function () {
        showFailure(instance, null, true);
      }).finally(function () {
        finish(operation);
      });
    };
  }

  var descriptor = Object.getOwnPropertyDescriptor(namespace, 'AjaxProduct');
  if (typeof namespace.AjaxProduct === 'function') {
    install(namespace.AjaxProduct);
  } else if (!descriptor) {
    Object.defineProperty(namespace, 'AjaxProduct', {
      configurable: true,
      enumerable: true,
      get: function () { return undefined; },
      set: function (Constructor) {
        Object.defineProperty(namespace, 'AjaxProduct', {
          value: Constructor, configurable: true, enumerable: true, writable: true
        });
        install(Constructor);
      }
    });
  }
})();
